module.exports = "/assets/37ecfc4844e96a96ac1214923cc6d1f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KP.png
// module id = 1553
// module chunks = 0